import { useEffect, useState } from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { Plus, AlertTriangle } from "lucide-react";
import { http } from "../../lib/api";

const NAV = [
  { to: "/extras", label: "Library", id: "ex-nav-library", end: true },
  { to: "/extras/usage", label: "AI spend", id: "ex-nav-usage" },
  { to: "/extras/feed", label: "Feed check", id: "ex-nav-feed" },
];

export const TYPE_LABEL = { kit: "Travel kit / guide", checklist: "Checklist / planner", itinerary: "Itinerary", bundle: "Bundle" };
export const media = (id) => (id ? `${process.env.REACT_APP_BACKEND_URL}/api/extras/media/${id}` : null);
export const aud = (n) => `A$${Number(n || 0).toFixed(2)}`;

const CreditBanner = () => {
  const [k, setK] = useState(null);
  useEffect(() => { http.get("/extras/usage").then(({ data }) => setK(data.key)).catch(() => {}); }, []);
  if (!k || k.remaining == null || k.remaining >= 5) return null;
  return (
    <div data-testid="ex-credit-banner" className="bg-[#FCEFEC] border-b border-[#F1D5CE] text-sm text-[#7A2E22]">
      <div className="max-w-6xl mx-auto px-8 py-2.5 flex items-center gap-2">
        <AlertTriangle size={15} /> OpenRouter credit is low: <b>{k.remaining <= 0 ? "US$0.00 (over budget)" : `US$${Number(k.remaining).toFixed(2)}`}</b> left. Top up at openrouter.ai/keys so the AI keeps working.
        <Link to="/extras/usage" className="underline font-medium ml-1">AI spend</Link>
      </div>
    </div>
  );
};

export default function ExtrasShell() {
  return (
    <div data-testid="extras-shell" className="ex min-h-screen">
      <header className="sticky top-0 z-20 bg-[#F7F4EE]/90 backdrop-blur border-b border-[#E6DDCF]">
        <div className="max-w-6xl mx-auto px-8 h-16 flex items-center gap-4">
          <Link to="/extras" className="flex items-center gap-3" data-testid="ex-home">
            <img src="/logo-full.png" alt="PB Travel Angel" className="h-10 w-auto" />
            <span className="ex-display text-lg font-semibold">PB Travel Angel</span>
            <span className="ex-mono text-[10px] tracking-[0.25em] text-stone-500 border-l border-stone-300 pl-3">PRODUCT STUDIO</span>
          </Link>
          <nav className="ml-auto flex items-center gap-5 text-sm">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.end} data-testid={n.id}
                className={({ isActive }) => `transition-colors ${isActive ? "text-[#2B241D] font-medium" : "text-stone-500 hover:text-[#2B241D]"}`}>{n.label}</NavLink>
            ))}
            <Link to="/extras/new" data-testid="ex-nav-new" className="ex-btn ex-btn-brown"><Plus size={15} /> New product</Link>
          </nav>
        </div>
      </header>
      <CreditBanner />
      <div className="max-w-6xl mx-auto px-8 py-12"><Outlet /></div>
    </div>
  );
}
